import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e56b7792")

_pushScopeId("data-v-e56b7792")
const _hoisted_1 = { class: "pagination" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    (_ctx.pageData.pagination.firstUrl && _ctx.pageData.pagination.currentPage !== 1)
      ? (_openBlock(), _createBlock("a", {
          key: 0,
          href: _ctx.pageData.pagination.firstUrl,
          title: "First Page",
          class: "btn"
        }, " First Page ", 8, ["href"]))
      : _createCommentVNode("", true),
    (_ctx.pageData.pagination.prevUrl)
      ? (_openBlock(), _createBlock("a", {
          key: 1,
          href: _ctx.pageData.pagination.prevUrl,
          title: "Previous Page",
          class: "btn"
        }, " Previous Page ", 8, ["href"]))
      : _createCommentVNode("", true),
    (_ctx.pageData.pagination.nextUrl)
      ? (_openBlock(), _createBlock("a", {
          key: 2,
          href: _ctx.pageData.pagination.nextUrl,
          title: "Next Page",
          class: "btn"
        }, " Next Page ", 8, ["href"]))
      : _createCommentVNode("", true),
    (_ctx.pageData.pagination.firstUrl && _ctx.pageData.pagination.currentPage !== _ctx.pageData.pagination.totalPages)
      ? (_openBlock(), _createBlock("a", {
          key: 3,
          href: _ctx.pageData.pagination.lastUrl,
          title: "Last Page",
          class: "btn"
        }, " Last Page ", 8, ["href"]))
      : _createCommentVNode("", true)
  ]))
})